import { render, staticRenderFns } from "./model-course.vue?vue&type=template&id=17a2ba5b&scoped=true&"
import script from "./model-course.vue?vue&type=script&lang=js&"
export * from "./model-course.vue?vue&type=script&lang=js&"
import style0 from "./model-course.vue?vue&type=style&index=0&id=17a2ba5b&lang=scss&scoped=true&"
import style1 from "./model-course.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2ba5b",
  null
  
)

export default component.exports